import React, { useState, useEffect, useRef } from "react";
import enableTableSearch from "../utility/table";
import ExportCSV from "./ExportCSV";
import API_BASE_URL from "../config";

function DivisionTable({ reload }) {
  const [divisions, setDivisions] = useState([]);
  const inputRef = useRef();
  const tableRef = useRef();

  useEffect(() => {
    fetch(API_BASE_URL + "/api/division")
      .then((res) => res.json())
      .then((data) => setDivisions(data.divisions))
      .catch((err) => console.error("Error fetching division:", err));
  }, [reload]);

  useEffect(() => {
    const cleanup = enableTableSearch({
      inputRef,
      tableRef,
      columnIndex: 1,
      noDataText: "No division found",
    });

    return cleanup;
  }, []);

  return (
    <div id="table-container">
      <div id="header">
        <p>Division List</p>
      </div>
      <hr />
      <div id="table-actions">
        <ExportCSV
          entries={divisions.map((item, index) => [item.name, item.address])}
          header={["NAME", "ADDRESS"]}
        />
        <div className="search-box">
          <label>Search:</label>
          <input type="text" id="search" name="search" ref={inputRef} />
        </div>
      </div>
      <table id="division-table">
        <thead>
          <tr>
            <th>SL NO.</th>
            <th>NAME</th>
            <th>ADDRESS</th>
          </tr>
        </thead>
        <tbody id="table-body" ref={tableRef}>
          {divisions.map((item, index) => (
            <tr key={item.id}>
              <td>{item.id}</td>
              <td>{item.name}</td>
              <td>{item.address}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default DivisionTable;
